import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom';

import BaseComponent from 'utils/BaseComponent'
import request from 'utils/request'
import { getMakerName, getBrandName, getModelName } from 'utils/vehicle'

import { VEHICLE_DETAIL_URL } from 'constants'

import RetractablePanel from 'components/RetractablePanel'

import { vehicleChanged } from 'scenes/VehicleDetail/actions'
import { edittingDataChanged } from 'scenes/VehicleDetail/components/Data/actions'
import { statusChanged } from 'components/RequestStatus/actions'

import EditForm from './EditForm'
import ConfirmationPhraseModal from 'components/ConfirmationPhraseModal'

import './styles.scss'

export class VehicleData extends BaseComponent {

  constructor(props) {
    super(props)

    this.state = {
      vehicle: []
    }

    this._bind('_renderHeaderActions', '_onEdit', '_onDelete', '_renderData', '_showConfirmationModal')
  }

  _onEdit(evt) {
    evt.preventDefault()
    this.panel.open()
    this.props.edittingDataChanged(true)
  }

  _onDelete() {
    this.props.updateRequestStatus('progress', 'Eliminando coche ...')
    request(VEHICLE_DETAIL_URL(this.props.userId, this.props.vehicleId), {
      method: 'DELETE',
      body: {  }
    })
    .then((res) => {
      this.props.updateRequestStatus(res.status, res.message)
      this.props.history.push(`/clientes/${this.props.userId}`)
    })
    .catch((res) => {
      this.props.updateRequestStatus('error', 'Ocurrio un error intenta más tarde')
    })
  }

  _renderHeaderActions() {
    return !this.state.editting ? (
      <div className="header-icons">
        <button onClick={this._showConfirmationModal}>
          <i className="material-icons">delete_forever</i>
        </button>
        <button onClick={this._onEdit}>
          <i className="material-icons">edit</i>
        </button>
      </div>
    ) : null
  }

  _showConfirmationModal(e){
    e.preventDefault()
    var title = "Confirmación para eliminar coche"
    var message = "Se eliminarán todos los documentos, pólizas, siniestros y actualizaciones del coche."
    var phrase = "ELIMINAR COCHE"
    this.context.toggleModal(
      true,
      <ConfirmationPhraseModal 
                          _onAccept={this._onDelete.bind(this)}
                          match={this.props.match} 
                          title={title}
                          acceptLabel="Eliminar"
                          message={message}
                          phrase={phrase}
                          hideModal={true}
      />
    )
  }

  _renderData() {
    const vehicle = this.props.vehicle

    return (
      <div className="VehicleData__data">
        <div>
          <span>Marca:</span>
          <strong>{getMakerName(vehicle)}</strong>
        </div>
        <div>
          <span>Línea:</span>
          <strong>{getBrandName(vehicle)}</strong>
        </div>
        <div>
          <span>Modelo:</span>
          <strong>{getModelName(vehicle)}</strong>
        </div>
        <div>
          <span>Número de motor:</span>
          <strong>{vehicle.engine_id}</strong>
        </div>
        <div>
          <span>Número de serie:</span>
          <strong>{vehicle.serial_number}</strong>
        </div>
        <div>
          <span>Placas:</span>
          <strong>{vehicle.plates}</strong>
        </div>
        <div>
          <span>Alias:</span>
          <strong>{vehicle.alias}</strong>
        </div>
      </div>
    )
  }

  render() {
    return (
      <RetractablePanel
        ref={(panel) => this.panel = panel}
        name="Datos del coche"
        actionButtons={this._renderHeaderActions()}
        isToggle={false} >
        {this.props.edittingData ? (
          <EditForm userId={this.props.userId}
                    vehicleId={this.props.vehicleId} />
          ) : (this._renderData()) }
      </RetractablePanel>
    )
  }
}

VehicleData.contextTypes = {
  toggleModal: PropTypes.func.isRequired
}

const mapStateToProps = (state) => {
  return {
    vehicle: state.vehicleDetail.get('vehicle').toObject(),
    edittingData: state.dataVehicleDetail.get('edittingData')
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    vehicleChanged: (vehicle) => dispatch(vehicleChanged(vehicle)),
    edittingDataChanged: (edittingData) => dispatch(edittingDataChanged(edittingData)),
    updateRequestStatus: (status, message) => dispatch(statusChanged(status, message))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(VehicleData))



// WEBPACK FOOTER //
// ./src/scenes/VehicleDetail/components/Data/VehicleData/index.js